// ============================================
// Datos del sitio - César Balarezo León
// Edita este archivo para actualizar contenido
// ============================================

export const SITE_CONFIG = {
  name: "César Balarezo León",
  shortName: "César Balarezo",
  initials: "CB",
  role: "Head of AI & Analytics",
  tagline: "IA aplicada. Data para decisiones. LATAM.",
  location: "Lima, Perú",
  email: "cesar.balarezo@balexus.com",
  linkedin: "linkedin.com/in/cbalarezol",
  linkedinUrl: "https://www.linkedin.com/in/cbalarezol",
};

// Redes sociales con métricas reales (actualizar manualmente cuando cambien)
export const SOCIAL_LINKS = [
  { id: "linkedin", label: "LinkedIn", handle: "@cbalarezol", url: "https://www.linkedin.com/in/cbalarezol", metric: "2.4K", metricLabel: "seguidores" },
  { id: "youtube", label: "YouTube", handle: "@cbalarezolpe", url: "https://www.youtube.com/@cbalarezolpe", metric: "8K", metricLabel: "suscriptores" },
  { id: "instagram", label: "Instagram", handle: "@cbalarezolpe", url: "https://www.instagram.com/cbalarezolpe", metric: "1.6K", metricLabel: "seguidores" },
  { id: "x", label: "X", handle: "@cbalarezol", url: "https://x.com/cbalarezol", metric: "351", metricLabel: "seguidores" },
];

export const POSTS = [
  {
    id: 1,
    slug: "chat-ipt-plataforma-ia-conversacional-vertex-ai",
    tag: "IA Generativa",
    title: "Cómo construí Chat IPT: una plataforma de IA conversacional enterprise con Vertex AI",
    excerpt:
      "Lecciones aprendidas al diseñar y desplegar un agente conversacional que transformó cómo 100+ empleados acceden a operaciones de red e inteligencia de negocio.",
    date: "28 Feb 2026",
    readTime: "7 min",
    // TODO: Agregar contenido completo del artículo
    content: null,
  },
  {
    id: 2,
    slug: "vertex-ai-dialogflow-cx-gemini-arquitectura",
    tag: "Arquitectura IA",
    title: "Vertex AI Agent Builder + Dialogflow CX + Gemini: La stack que elegí y por qué",
    excerpt:
      "Un deep dive técnico en la arquitectura end-to-end que conecta BigQuery, Microsoft Graph API, Freshservice y WhatsApp Business.",
    date: "21 Feb 2026",
    readTime: "9 min",
    content: null,
  },
  {
    id: 3,
    slug: "ia-telecomunicaciones-rurales-brecha-digital",
    tag: "Transformación Digital",
    title: "IA en telecomunicaciones rurales: cerrando la brecha digital con datos",
    excerpt:
      "Cómo la IA predictiva y generativa están acelerando la conectividad en las zonas más remotas de Perú y Latinoamérica.",
    date: "14 Feb 2026",
    readTime: "6 min",
    content: null,
  },
  {
    id: 4,
    slug: "analista-comercial-head-ai-18-anos-telecom",
    tag: "Liderazgo",
    title: "De analista comercial a Head of AI: lo que 18 años en telecom me enseñaron sobre liderar con datos",
    excerpt:
      "No se trata solo de la tecnología. Se trata de diseñar sistemas que los equipos realmente adoptan y que generan impacto medible.",
    date: "7 Feb 2026",
    readTime: "5 min",
    content: null,
  },
];

export const SERVICES = [
  {
    icon: "🧠",
    title: "Consultoría en IA Enterprise",
    desc: "Diagnóstico, arquitectura y hoja de ruta para implementar IA generativa y agéntica en tu organización.",
  },
  {
    icon: "⚡",
    title: "Agentes Conversacionales",
    desc: "Diseño y desarrollo de chatbots y agentes IA integrados a tus sistemas corporativos (BigQuery, APIs, CRM).",
  },
  {
    icon: "🎯",
    title: "Workshops & Capacitación",
    desc: "Entrenamiento práctico para equipos en herramientas de IA generativa, prompt engineering y adopción responsable.",
  },
  {
    icon: "📊",
    title: "Data & Analytics Strategy",
    desc: "Gobernanza de datos, BI, dashboards y modelos predictivos para transformar datos en decisiones de negocio.",
  },
];

export const TECH_STACK = [
  "Vertex AI",
  "Gemini",
  "Dialogflow CX",
  "BigQuery",
  "Google Cloud",
  "Python",
  "React",
  "TypeScript",
  "Power BI",
  "n8n",
  "Qdrant",
  "LLMs",
];

export const EDUCATION = [
  {
    institution: "MIT Professional Education",
    title: "IA Generativa Aplicada a Transformación Digital",
    year: "2024-2025",
  },
  {
    institution: "MIT xPRO",
    title: "Diseño y Desarrollo de Productos de IA",
    year: "2023",
  },
  {
    institution: "PAD - Universidad de Piura",
    title: "Master of Business Administration (MBA)",
    year: "2015-2017",
  },
  {
    institution: "IESE Business School",
    title: "Innovation Management Program",
    year: "2017",
  },
];

export const STATS = [
  { num: "18+", label: "Años en Telco & Tech" },
  { num: "100+", label: "Usuarios plataforma IA" },
  { num: "8K", label: "Suscriptores YouTube" },
  { num: "50", label: "Videos publicados" },
  { num: "7", label: "Series editoriales" },
];

// Chatbot config movido al backend (server/routes/chat.js)
// El frontend solo necesita la URL del API, configurada via VITE_API_URL

// Asistente IA interactivo (ElevenLabs + HeyGen)
export const AI_ASSISTANT_CONFIG = {
  sectionTag: "Asistente IA",
  sectionTitle: "Conversa conmigo",
  sectionSubtitle:
    "Interactúa con mi asistente de IA por voz o video. Pregúntale sobre mis servicios, experiencia o cualquier tema de IA enterprise.",
  elevenlabs: {
    // Fallback inicial. El estado real se gestiona desde /admin → APIs.
    enabled: true,
    agentId: import.meta.env.VITE_ELEVENLABS_AGENT_ID || "",
    // Personalización del widget
    accentColor: "#5CE0BE",
    backgroundColor: "#080810",
    textColor: "#EAEAEA",
    label: "Asistente de voz",
    description: "Habla con mi asistente IA en tiempo real",
  },
  heygen: {
    // Para ocultar el avatar de video sin perder la configuración: poner enabled en false.
    // Para reactivarlo en el futuro: cambiar a true. Si avatarId está vacío, tampoco se muestra.
    enabled: false,
    avatarId: import.meta.env.VITE_HEYGEN_AVATAR_ID || "",
    label: "Avatar interactivo",
    description: "Conversa con mi avatar digital cara a cara",
  },
};

// Posts recientes en redes sociales (actualizar manualmente)
export const SOCIAL_POSTS = {
  x: [
    { text: "NVIDIA GTC 2026: El análisis completo de lo que viene en IA enterprise", url: "https://x.com/cbalarezol", date: "18 Mar 2026" },
    { text: "IBM vs Claude Code — La gran disrupción en desarrollo con IA", url: "https://x.com/cbalarezol", date: "15 Mar 2026" },
    { text: "¿La IA viene por tu trabajo? Mi perspectiva después de 18 años en telecom", url: "https://x.com/cbalarezol", date: "12 Mar 2026" },
    { text: "Los 3 tipos de profesionales ante la IA: ¿en cuál estás tú?", url: "https://x.com/cbalarezol", date: "10 Mar 2026" },
    { text: "MWC 2026: La era de la IA en telecomunicaciones ha comenzado", url: "https://x.com/cbalarezol", date: "7 Mar 2026" },
  ],
  linkedin: [
    { text: "Chat IPT: Cómo diseñé una plataforma IA conversacional para 100+ usuarios en Internet para Todos", url: "https://www.linkedin.com/in/cbalarezol/recent-activity/all/", date: "19 Mar 2026" },
    { text: "Datacenters y Telcos en Latam: La brecha de infraestructura que frena la IA", url: "https://www.linkedin.com/in/cbalarezol/recent-activity/all/", date: "16 Mar 2026" },
    { text: "De la PPT a modelos de IA: el salto que toda empresa debe dar", url: "https://www.linkedin.com/in/cbalarezol/recent-activity/all/", date: "13 Mar 2026" },
    { text: "El Iceberg de la IA: Lo que no ves debajo de la superficie de ChatGPT", url: "https://www.linkedin.com/in/cbalarezol/recent-activity/all/", date: "9 Mar 2026" },
    { text: "Mustafa Suleyman y el fin del trabajo de oficina: mi análisis desde telecom", url: "https://www.linkedin.com/in/cbalarezol/recent-activity/all/", date: "5 Mar 2026" },
  ],
};

// Navegación principal — 5 destinos consolidados
// /proyectos entra al nav (evidencia practicante-constructor); el asistente
// sigue vivo en /asistente, accesible desde el hero ("Hablar por voz") y el footer.
export const NAV_LINKS = [
  { path: "/", labelKey: "nav.home" },
  { path: "/proyectos", labelKey: "nav.projects" },
  { path: "/contenido", labelKey: "nav.content" },
  { path: "/sobre-mi", labelKey: "nav.about" },
  { path: "/servicios", labelKey: "nav.work" },
];

// Rutas internas accesibles por URL directa pero no en el nav
export const ALL_ROUTES = [
  ...NAV_LINKS,
  { path: "/asistente", labelKey: "nav.assistant" },
  { path: "/insights", labelKey: "nav.insights" },
  { path: "/redes", labelKey: "nav.social" },
  { path: "/agendar", labelKey: "nav.booking" },
  { path: "/contacto", labelKey: "nav.contact" },
];
